var _ellipse, _path, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmo3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.2277,
    cy: 66.1816,
    rx: 40.2277,
    ry: 22.1816,
    fill: "#52537A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3381 100.001C60.195 93.8821 66.0666 75.1865 67.0203 66.6035L58.6568 66.3341C63.9275 74.4624 51.3071 92.1653 44.3381 100.001Z",
    fill: "#52537A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 67.3368,
    y1: 75.2435,
    x2: 85.289,
    y2: 58.2444,
    stroke: "#F1BBEE",
    strokeWidth: 4.83801
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 62.0855,
    y1: 66.479,
    x2: 70.1488,
    y2: 74.5423,
    stroke: "#F1BBEE",
    strokeWidth: 4.83801
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmo3);
export default __webpack_public_path__ + "static/media/emo-3.e9a1e3ba4dfa4c27ffd6d277888511bc.svg";
export { ForwardRef as ReactComponent };